module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("为什么作者直接删除了我在 issue 下的评论")]), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_c('p', [_vm._v("被删除评论一般是因为：你在 issue 下写了一条和当前 issue 没有关系的评论，或者提了和 issue 无关的问题。")])]), _vm._v(" "), _c('p', [_vm._v("即使是关于同一个组件，和当前 issue 讨论主题无关的评论也会造成管理麻烦，影响讨论。")]), _vm._v(" "), _c('p', [_vm._v("作为维护者我们想让每条 issue 讨论主题集中，以便管理追踪。")]), _vm._v(" "), _c('p', [_vm._v("作为 issue 创建者同样如此，试想你愿意别人在你的网站发无关内容或者垃圾吗？")]), _vm._v(" "), _c('p', [_vm._v("尊重他人，理解作为维护者管理每条 issue 所花费的时间精力再提问可以得到更好和更快的帮助。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-50860e2a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-50860e2a"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/why-delete-my-issue-comment-63.vue
// module id = 2731
// module chunks = 189